export default __webpack_public_path__ + "static/media/Rock_img.323e1f11.png";